import {QueryFunctionContext} from 'react-query';

import request from '../../axios';

const getAddressByLatLngSearch = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IAddress} = await request.get(
    `api/v2/store/coordinate-based-search?coordinate=POINT (${ctx.queryKey[1]} ${ctx.queryKey[2]})`,
  );
  return data;
};

export default getAddressByLatLngSearch;
